
export default [
  {
    path: "/qspiFSPI",
    name:"fspi",
    component: () =>
      import("@/components/page/QSPI/FSPI/fspiQuery"),
    meta: { title: "FSPI" },
  },
  {
    path: "/qspiFSPI/detail",
    name:"fspiDetail",
    component: () =>
      import("@/components/page/QSPI/FSPI/fspiDetail"),
    meta: { title: "维护FSPI" },
  },
  {
    path: "/qspiFSPI/history",
    name:"viewHistory",
    component: () =>
      import("@/components/page/QSPI/FSPI/viewHistory"),
    meta: { title: "FSPI修改日志" },
  },
];
